import React from "react";
import { Chip, Paper, Stack, Typography } from "@mui/material";

export default function OrderHistoryView({ orders = [] }) {
  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Bestellhistorie
      </Typography>
      <Stack spacing={2}>
        {orders.map((order) => (
          <Paper key={order.id} variant="outlined" sx={{ p: 2 }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <div>
                <Typography variant="subtitle1">Bestellung {order.purchaseOrderNumber}</Typography>
                <Typography variant="body2" color="text.secondary">
                  Lieferant: {order.supplierName ?? order.supplierId}
                </Typography>
              </div>
              <Chip label={order.status} color="primary" variant="outlined" />
            </Stack>
          </Paper>
        ))}
        {orders.length === 0 && (
          <Typography variant="body2" color="text.secondary">
            Noch keine Bestellungen vorhanden.
          </Typography>
        )}
      </Stack>
    </Paper>
  );
}
